import { createReducer } from 'redux-act';

import {
  ACTIONS_NAMES_DICT,
  STATIONS_DATA_ACTIONS as ACTIONS,
} from 'state/actions/stationsData';

const initialState = {
  data: [],
  lastData: {},
  lastStatus: {},
  installationData: {},
  loading: false,
  lastDataIsLoading: false,
  installationDataIsLoading: false,
  isDarkening: false,
  isProcessingDarkeningSNR: false,
  isProcessingDarkeningSNRSuccess: false,
  darkeningStartedAt: null,
  darkeningStoppedAt: null,
  darkeningSNR: null,
  error: null,
  success: false,
  archived: false,
};

export const stationsDataReducer = createReducer(
  {
    [ACTIONS[ACTIONS_NAMES_DICT.FETCH_DATA_INIT]]: (state) => ({
      ...state,
      loading: true,
    }),
    [ACTIONS[ACTIONS_NAMES_DICT.FETCH_DATA_SUCCESS]]: (state, payload) => ({
      ...state,
      data: payload.data,
      loading: false,
      error: null,
    }),
    [ACTIONS[ACTIONS_NAMES_DICT.FETCH_DATA_FAIL]]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [ACTIONS[ACTIONS_NAMES_DICT.FETCH_LAST_DATA_INIT]]: (state) => ({
      ...state,
      lastDataIsLoading: true,
    }),
    [ACTIONS[ACTIONS_NAMES_DICT.FETCH_LAST_DATA_SUCCESS]]: (
      state,
      payload
    ) => ({
      ...state,
      lastData: payload.lastData,
      lastStatus: payload.lastStatus,
      lastDataIsLoading: false,
      error: null,
    }),
    [ACTIONS[ACTIONS_NAMES_DICT.FETCH_LAST_DATA_FAIL]]: (state, payload) => ({
      ...state,
      lastDataIsLoading: false,
      error: payload.error,
    }),
    [ACTIONS[ACTIONS_NAMES_DICT.FETCH_INSTALLATION_DATA_INIT]]: (state) => ({
      ...state,
      installationDataIsLoading: true,
    }),
    [ACTIONS[ACTIONS_NAMES_DICT.FETCH_INSTALLATION_DATA_SUCCESS]]: (
      state,
      payload
    ) => ({
      ...state,
      installationData: payload.data,
      installationDataIsLoading: false,
      error: null,
    }),
    [ACTIONS[ACTIONS_NAMES_DICT.FETCH_INSTALLATION_DATA_FAIL]]: (
      state,
      payload
    ) => ({
      ...state,
      installationDataIsLoading: false,
      error: payload.error,
    }),
    [ACTIONS[ACTIONS_NAMES_DICT.CLEAN_UP]]: (state) => ({
      ...state,
      loading: false,
      error: null,
      success: false,
      archived: false,
    }),
    [ACTIONS[ACTIONS_NAMES_DICT.CLEAR_DATA_LOGOUT]]: () => ({
      ...initialState,
    }),
    [ACTIONS[ACTIONS_NAMES_DICT.DARKENING_START]]: (state, payload) => ({
      ...state,
      isDarkening: true,
      darkeningStartedAt:
        payload.darkeningStartedAt || new Date().toISOString(),
      darkeningStoppedAt: null,
      darkeningSNR: null,
      isProcessingDarkeningSNR: false,
      isProcessingDarkeningSNRSuccess: false,
    }),
    [ACTIONS[ACTIONS_NAMES_DICT.DARKENING_STOP]]: (state) => ({
      ...state,
      isDarkening: false,
      darkeningStoppedAt: new Date().toISOString(),
      darkeningSNR: null,
      isProcessingDarkeningSNR: false,
      isProcessingDarkeningSNRSuccess: false,
    }),
    [ACTIONS[ACTIONS_NAMES_DICT.DARKENING_FAIL]]: (state) => ({
      ...state,
      isDarkening: false,
      darkeningStartedAt: null,
      darkeningStoppedAt: null,
      darkeningSNR: null,
      isProcessingDarkeningSNR: false,
      isProcessingDarkeningSNRSuccess: false,
    }),
    [ACTIONS[ACTIONS_NAMES_DICT.DARKENING_RESET]]: (state) => ({
      ...state,
      isDarkening: false,
      darkeningStartedAt: null,
      darkeningStoppedAt: null,
      darkeningSNR: null,
      isProcessingDarkeningSNR: false,
      isProcessingDarkeningSNRSuccess: false,
    }),
    [ACTIONS[ACTIONS_NAMES_DICT.PROCESS_DARKENING_SNR_INIT]]: (state) => ({
      ...state,
      darkeningSNR: null,
      isProcessingDarkeningSNR: true,
      isProcessingDarkeningSNRSuccess: false,
    }),
    [ACTIONS[ACTIONS_NAMES_DICT.PROCESS_DARKENING_SNR_SUCCESS]]: (
      state,
      payload
    ) => ({
      ...state,
      darkeningSNR: payload.darkeningSNR,
      isProcessingDarkeningSNR: false,
      isProcessingDarkeningSNRSuccess: true,
    }),
    [ACTIONS[ACTIONS_NAMES_DICT.PROCESS_DARKENING_SNR_FAIL]]: (state) => ({
      ...state,
      darkeningSNR: null,
      isProcessingDarkeningSNR: false,
      isProcessingDarkeningSNRSuccess: false,
    }),
  },
  initialState
);
